import { render, staticRenderFns } from "./headlines-needs.vue?vue&type=template&id=ece2daa0&scoped=true&"
import script from "./headlines-needs.vue?vue&type=script&lang=js&"
export * from "./headlines-needs.vue?vue&type=script&lang=js&"
import style0 from "./headlines-needs.vue?vue&type=style&index=0&id=ece2daa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece2daa0",
  null
  
)

export default component.exports